<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div class="benefit">
        <p>Benefits</p>
        <div class="benefit__div">
          <div class="page-loader" v-show="pageLoading">
            <div>
              <PageLoader />
            </div>
          </div>

          <div v-show="!pageLoading">
            <div class="data-fetch-error" v-show="dataFetchError">
              <p>This page did not load successfully. Please refesh.</p>
            </div>
          </div>

          <!-- start hmos -->
          <div class="benefit__div--content" v-show="!pageLoading">
            <div class="benefit__div--content-header">
              <div class="benefit__div--content-header-text">
                <span>HMO Benefits</span>
                <p>
                  Here, you will find a list of all the HMO benefits your
                  company is currently offering employees.
                </p>
              </div>

              <div
                class="benefit__div--content-header-btn"
                v-if="manager !== 1"
              >
                <div>
                  <routerLink to="/create-hmo">
                    <div>
                      <font-awesome-icon icon="plus" />&nbsp;Create New HMO
                    </div>
                  </routerLink>
                </div>
              </div>
            </div>

            <div
              class="alert d-flex align-items-center"
              role="alert"
              v-if="noBenefitData"
            >
              <font-awesome-icon icon="times-circle" />
              <p>There are no hmo providers created yet.</p>
            </div>

            <div class="benefit__div--content-section">
              <div v-for="(hmo, index) in hmos" :key="index">
                <div>
                  <!-- <div class="benefit__div--content-section-create-image">
                    <img
                      :src="hmo.logo"
                      alt
                    />
                  </div>-->
                  <div class="benefit__div--content-section-create-list">
                    <h5>{{ hmo.provider }}</h5>
                    <ul>
                      <li>{{ hmo.plans.length }} Health Plans</li>
                      <!-- <li>24 Hospitals</li>
                      <li>120 employees enrolled</li>-->
                    </ul>
                  </div>
                  <div class="benefit__div--content-section-create-view">
                    <routerLink
                      :to="{ name: 'hmoSummary', params: { id: hmo.id } }"
                    >
                      View
                      <font-awesome-icon icon="caret-right" />
                    </routerLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end hnos -->

          <div class="benefit__div--content" v-show="!pageLoading">
            <div class="benefit__div--content-header">
              <div class="benefit__div--content-header-text">
                <span>Other Benefits</span>
                <p>
                  Here, you will find a list of all the benefits your company is
                  paying your employees.
                </p>
              </div>
              <div
                class="benefit__div--content-header-btn"
                v-if="manager !== 1"
              >
                <div @click="showCreateBenefit">
                  <font-awesome-icon icon="plus" />&nbsp;Add New Benefits
                </div>
              </div>
            </div>
            <div class="benefit__div--content-section">
              <div v-for="(benefit, index) in otherBenefits" :key="index">
                <div>
                  <div class="benefit__div--content-section-create-add">
                    <img
                      src="./../../../assets/style/images/parcel.svg"
                      alt="benefit"
                    />
                  </div>
                  <div class="benefit__div--content-section-create-enrol">
                    <h5>{{ benefit.name }}</h5>
                    <!-- <p>12 employees enrolled</p> -->
                  </div>
                  <div class="benefit__div--content-section-create-view">
                    <routerLink
                      :to="{
                        name: 'benefitSummary',
                        params: { id: benefit.id },
                      }"
                    >
                      View
                      <font-awesome-icon icon="caret-right" />
                    </routerLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CreateBenefit
      v-if="createBenefit"
      @closeCreateBenefit="closeCreateBenefit"
    />
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import CreateBenefit from "./createBenefit";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "Benefit",
  components: {
    Header,
    Sidebar,
    CreateBenefit,
    PageLoader,
  },
  data() {
    return {
      item: "benefit",
      createBenefit: false,

      hmos: [],
      otherBenefits: [],

      dataFetchError: false,

      pageLoading: true,

      noBenefitData: false,
      manager: 1,
    };
  },
  metaInfo: {
    title: 'Employee Benefits Management - Maximize Your HR Offerings',
    meta: [
      { name: 'description', content: ' Manage employee benefits effectively with HR Desk. Offer competitive benefits packages, track enrollments, and enhance employee satisfaction.' },
      { property: 'og:title', content: 'Employee Benefits Management - Maximize Your HR Offerings' },
      { property: 'og:description', content: ' Manage employee benefits effectively with HR Desk. Offer competitive benefits packages, track enrollments, and enhance employee satisfaction.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/benefits' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Employee Benefits Management - Maximize Your HR Offerings' },
      { name: 'twitter:description', content: ' Manage employee benefits effectively with HR Desk. Offer competitive benefits packages, track enrollments, and enhance employee satisfaction.' },
      { name: 'keywords', content: 'employee benefits, benefits management, HR benefits, employee satisfaction, benefits packages' },
    ]
  },
  created() {
    this.getHmos();
    this.getOtherBenefits();
    this.getManagerLevel();
  },
  methods: {
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId =
          this.$store.getters.currentAuthUser.employees.company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then((resp) => {
          this.$store.state.managedClient = resp.data.data.managed;
          this.manager = this.$store.state.managedClient;
        });
      } else {
        this.manager = this.$store.state.managedClient;
      }
    },
    showCreateBenefit() {
      this.createBenefit = true;
    },
    closeCreateBenefit(reloadData = false) {
      if (reloadData) {
        this.getOtherBenefits();
      }
      this.createBenefit = false;
    },
    getHmos() {
      this.pageLoading = true;
      this.noBenefitData = false;

      this.$http
        .get(types.GET_HMOS_API)
        .then((resp) => {
          this.pageLoading = false;
          this.hmos = resp.data.data;
          if (this.hmos.length) {
            return;
          }
          this.noBenefitData = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    getOtherBenefits() {
      this.pageLoading = true;

      this.$http
        .get(types.GET_OTHER_BENEFITS_API)
        .then((resp) => {
          this.pageLoading = false;
          this.otherBenefits = resp.data.data.data;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.benefit {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .alert {
    font-size: 1rem;
    svg {
      margin-right: 7px;
    }
    p {
      margin-bottom: 0;
    }
  }

  .page-loader {
    margin-top: 100px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .data-fetch-error {
    margin-top: 10px;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
    p {
      margin-bottom: 0;
      padding-top: 20px;
      text-align: left;
    }
  }

  > p {
    font-size: 2.083rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  > .benefit__div {
    border-top: 1px solid #caced5;
    padding: 0 5px;

    > .benefit__div--content {
      margin-top: 30px;
      margin-bottom: 100px;

      > .benefit__div--content-header {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: space;
        border-bottom: 1px solid rgba(202, 206, 213, 0.29);

        @media (max-width: 768px) {
          flex-direction: column;
        }

        > .benefit__div--content-header-text {
          width: 80%;

          > span {
            font-size: 1.458rem;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }

          > p {
            font-size: 1.042rem;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }
        }

        > .benefit__div--content-header-btn {
          width: 20%;
          @media (max-width: 768px) {
            width: 90%;
          }

          > div {
            min-width: 12rem;
            height: 38px;
            margin: auto;
            border-radius: 2px;
            background-color: #5099de;
            font-size: 0.938rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: left;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;

            > a {
              color: #ffffff;
              text-decoration: none;

              > div {
                height: 38px;
                display: flex;
                font-size: 0.938rem;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
              }
            }
          }
        }
      }

      > .benefit__div--content-section {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        > div {
          width: 25%;
          padding: 0 10px;
          margin-bottom: 20px;

          > div {
            max-width: 281.3px;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
            padding: 20px;
            cursor: pointer;

            &:hover {
              box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
            }

            > .benefit__div--content-section-create-image {
              max-width: 200px;
              height: 70px;
              margin-bottom: 10px;
              overflow: hidden;
              img {
                height: 70px;
              }
            }

            > .benefit__div--content-section-create-add {
              width: 47px;
              object-fit: contain;
              margin-bottom: 10px;
              overflow: hidden;
            }

            > .benefit__div--content-section-create-other {
              width: 37px;
              object-fit: contain;
              margin-bottom: 10px;
              overflow: hidden;
            }

            > .benefit__div--content-section-create-list {
              h5 {
                text-transform: capitalize;
              }
              padding: 20px 0;
              > ul {
                list-style: none;
                margin: 0;
                padding: 0;
                > li {
                  margin-bottom: 10px;
                  border-radius: 2px;
                  font-size: 16rem;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.5;
                  letter-spacing: normal;
                  text-align: left;
                  color: #707070;
                }
              }
            }

            > .benefit__div--content-section-create-enrol {
              h5 {
                text-transform: capitalize;
              }
              > span {
                text-transform: capitalize;
                font-size: 1.25rem;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }

              > p {
                font-size: 0.833rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: left;
                margin-top: 20px;
                color: #707070;
              }
            }

            > .benefit__div--content-section-create-text {
              padding: 20px 0;

              > span {
                font-size: 1.25rem;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }

              > p {
                font-size: 0.833rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: left;
                color: #707070;
                margin: 20px 0;
              }
            }

            > .benefit__div--content-section-create-view {
              font-size: 0.938rem;
              font-weight: 600;
              font-style: normal;
              font-stretch: normal;
              line-height: 2.22;
              letter-spacing: normal;
              text-align: left;
              color: #5099de;
              padding-top: 10px;
              border-top: 1px solid rgba(202, 206, 213, 0.29);

              > a {
                color: #5099de;
                text-decoration: none;
              }
            }

            > .benefit__div--content-section-create-btn {
              width: 6.615vw;
              height: 38px;
              border-radius: 2px;
              background-color: #5099de;
              font-size: 0.781rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: left;
              color: #ffffff;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
            }
          }
        }
      }
    }
  }
}
</style>
